import type {
  IntermediaryEnum,
  OverrideStatusEnum,
} from 'src/common/external/bambi-api/bambiApi';

// Broker intermediaries whose requested trips auto-accept on the broker
// side when the dispatcher hits assign — trip.assign() on the backend
// calls trip.accept() transparently and pushes the acceptance through
// the broker client. For these trips the frontend can skip the
// accept-request confirmation modal: the extra click adds no value.
//
// Mirrors backend MOMENTM_INTERMEDIARIES (apps/brokers/constants.py).
const AUTO_ACCEPT_INTERMEDIARIES: ReadonlySet<IntermediaryEnum> =
  new Set<IntermediaryEnum>([
    'momentm',
    'cts',
    'welltrans',
    'tennessee_carriers',
  ]);

// True when a requested trip should route through the accept-request
// modal. False for non-requested status or for broker trips that
// auto-accept upstream.
export function shouldUseAcceptRequestModal({
  intermediary,
  status,
}: {
  intermediary?: IntermediaryEnum | null;
  status: OverrideStatusEnum;
}): boolean {
  if (status !== 'requested') return false;
  if (intermediary && AUTO_ACCEPT_INTERMEDIARIES.has(intermediary)) {
    return false;
  }
  return true;
}
